/**
 * The Insight report open in the read-only shared view (My reports → a report). While it is open every
 * API call names it in the X-Insight-Report header, so the report's data endpoints let in the people
 * its Access tab names (useradmin services/insight_report_access.py, permission_or_report).
 */
let current: string | null = null;

export const setOpenInsightReport = (slug: string | null): void => { current = slug; };
export const openInsightReport = (): string | null => current;
